import React from 'react';
import LinearProgressBar from '../Graph/LinearProgress';

const Bar = ({ name, value, total, color }:any) => (
  <div style={{ padding: "15px" }}>
    <div style={{ padding: "15px 0 20px 0" }}>
      {name}
    </div>
    <div>
      <div>
        <LinearProgressBar
          progress={value}
          total={total}
          color={color}
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginRight: "60px",
          fontSize: "14px",
          color: "#a7aaad",
        }}
      >
        <div>0</div>
        <div>{total}</div>
      </div>
    </div>
  </div>
);

const FourBarContainer = ({ total, bar1, bar2, bar3, bar4 }:any) => (
  <div style={{ display: "flex", marginBottom: "20px" }}>
    <div
      style={{
        flex: 1.75,
        borderTop: "1px solid #eeeff2",
        borderRight: "1px solid #eeeff2",
      }}
    >
      <Bar {...bar1} total={total} color={"#3baff6"} />
      <Bar {...bar2} total={total} color={"#3baff6"} />
    </div>
    <div
      style={{
        flex: 1.75,
        borderTop: "1px solid #eeeff2",
        borderRight: "1px solid #eeeff2",
      }}
    >
      <Bar {...bar3} total={total} color={"#3baff6"} />
      <Bar {...bar4} total={total} color={"#3baff6"} />
    </div>
  </div>
);

export default FourBarContainer;
